<template>
    <b-modal id="modal-add-manifest" centered hide-footer no-close-on-backdrop :body-class="'px-4 pb-4 pt-3'"
        no-close-on-esc>
        <template #modal-header="{ close }">
            <h5 class="modal-title">
                {{ $t('addManifest.title') }}
            </h5>
            <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                Close Modal
            </b-button>
        </template>
        <div class="d-block">
            <b-row>
                <b-col sm="12">
                    <div class="upload-btn-wrapper" :class="uploadedFiles.length > 0 ? 'h-auto' : 'h-240px'"
                        @dragover.prevent="onDragOver" @dragleave.prevent="onDragLeave" @drop.prevent="onDrop"
                        :style="{ border: isDragging ? '2px dashed #007bff' : '' }">
                        <div v-if="uploadedFiles.length === 0" class="text-center">
                            <b-img class="img-2" :src="require('@/assets/drop.svg')"></b-img>
                            <button class="foo-2 w-100">
                                {{ $t('addManifest.dropDocuments') }}
                                <br />
                                <span class="font-12 text-muted">{{ $t('addManifest.supports') }}</span>
                            </button>
                            <input ref="manifestFile" type="file" name="manifestFile" multiple
                                accept=".pdf, .png, .jpg, .jpeg" @change="onFileChange" />
                        </div>

                        <!-- Files Display Section -->
                        <div v-else class="files-list-container">
                            <div class="d-flex align-items-center justify-content-between mb-3">
                                <h6 class="mb-0">{{ $t('addManifest.selectedFiles', { count: uploadedFiles.length }) }}</h6>
                                <b-button size="sm" variant="outline-primary" @click="$refs.manifestFile.click()">
                                    {{ $t('addManifest.addMore') }}
                                </b-button>
                            </div>

                            <div class="files-list">
                                <div v-for="(file, index) in uploadedFiles" :key="index"
                                    class="file-item d-flex align-items-center justify-content-between p-2 mb-2">
                                    <div class="d-flex align-items-center flex-grow-1">
                                        <div class="file-icon mr-3">
                                        </div>
                                        <div class="file-info">
                                            <p class="mb-0 font-weight-bold font-14 pre-line w-250px">{{ file.name }}</p>
                                            <p class="mb-0 text-muted font-12">
                                                {{ getFileType(file.name) }}
                                            </p>
                                        </div>
                                    </div>

                                    <b-img :src="require('@/assets/Close.svg')" class="manifest-file-remove"
                                        @click="removeFile(index)" width="20"></b-img>
                                </div>
                            </div>

                            <input ref="manifestFile" type="file" name="manifestFile" multiple
                                accept=".pdf, .png, .jpg, .jpeg" @change="onFileChange" class="d-none" />
                        </div>

                        <p v-if="bulkFileUploadErrors && bulkFileUploadErrors.document" class="field-error mt-2">
                            {{ bulkFileUploadErrors.document[0] }}
                        </p>
                    </div>
                </b-col>
            </b-row>
        </div>
        <div class="text-right modal-footer border-0 p-0 mt-3">
            <b-button class="mx-0 mr-3 h-40px w-100px" variant="secondary" @click="closeModal">{{ $t('addManifest.cancel') }}</b-button>
            <b-button class="mx-0 mb-0 h-40px w-100px mt-0" variant="primary" @click="saveManifests">
                {{ $t('addManifest.save') }}
            </b-button>
        </div>
    </b-modal>
</template>
<script>
import { mapActions } from "vuex";
export default {
    name: "AddManifest",
    props: ["loadId"],
    data() {
        return {
            uploadedFiles: [],
            isDragging: false,
            bulkFileUploadErrors: null,
            filePreviews: {},
        };
    },
    methods: {
        ...mapActions(['addHazmatManifestFiles', 'setNotification', 'setLoader']),
        resetFields() {
            this.uploadedFiles = [];
            this.isDragging = false;
            this.bulkFileUploadErrors = null;
            this.filePreviews = {};
            if (this.$refs.manifestFile) {
                this.$refs.manifestFile.value = '';
            }
        },

        onFileChange(event) {
            const files = Array.from(event.target.files);
            this.addFiles(files);
        },

        onDragOver() {
            this.isDragging = true;
        },

        onDragLeave() {
            this.isDragging = false;
        },

        onDrop(event) {
            this.isDragging = false;
            const files = Array.from(event.dataTransfer.files);
            this.addFiles(files);
        },

        addFiles(files) {
            const validFiles = files.filter(file => {
                const validTypes = ['application/pdf', 'image/png', 'image/jpg', 'image/jpeg'];
                const isValid = validTypes.includes(file.type);

                if (!isValid) {
                    this.$bvToast.toast(this.$t('addManifest.notSupported', { name: file.name }), {
                        title: this.$t('addManifest.invalidFileType'),
                        variant: 'warning',
                        solid: true
                    });
                }

                return isValid;
            });

            this.uploadedFiles = [...this.uploadedFiles, ...validFiles];



            if (this.$refs.manifestFile) {
                this.$refs.manifestFile.value = '';
            }
        },

        removeFile(index) {
            const file = this.uploadedFiles[index];
            this.uploadedFiles.splice(index, 1);

            if (this.filePreviews[file.name]) {
                delete this.filePreviews[file.name];
            }
        },


        generatePreview(file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                this.$set(this.filePreviews, file.name, e.target.result);
            };
            reader.readAsDataURL(file);
        },

        getFilePreview(file) {
            return this.filePreviews[file.name] || require('@/assets/img.svg');
        },

        formatFileSize(bytes) {
            if (bytes === 0) return '0 Bytes';
            const k = 1024;
            const sizes = ['Bytes', 'KB', 'MB', 'GB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
        },

        getFileType(fileName) {
            const extension = fileName.split('.').pop().toUpperCase();
            return extension;
        },

        closeModal() {
            this.$bvModal.hide('modal-add-manifest');
            this.resetFields();
        },

        async saveManifests() {
            if (this.uploadedFiles.length === 0) {
                this.bulkFileUploadErrors = {
                    document: [this.$t('addManifest.pleaseSelectFile')]
                };
                return;
            }
            try {
                this.setLoader(true);
                const formData = new FormData();
                this.uploadedFiles.forEach((file) => {
                    formData.append('file', file);
                });
                await this.addHazmatManifestFiles({ loadId: this.loadId, formData });
                this.$emit("getManifestFiles");
                await this.setNotification({
                    msg: this.$t('addManifest.manifestAdded'),
                    type: "success",
                    color: "green",
                });
                this.closeModal();
                this.setLoader(false);
            }
            catch (error) {
                this.setLoader(false);
                await this.setNotification({
                    msg: this.$t('addManifest.uploadError'),
                    type: "error",
                    color: "red",
                });

            }
        },
    },
};
</script>

<style scoped>
.upload-btn-wrapper {
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 2px dashed #ccc;
    border-radius: 8px;
    padding: 20px;
    transition: all 0.3s ease;
}

.upload-btn-wrapper input[type=file] {
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
}

.files-list-container {
    width: 100%;
}

.files-list {
    max-height: 400px;
    overflow-y: auto;
}

.file-item {
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    transition: all 0.2s ease;
}

.file-item:hover {
    background-color: #e9ecef;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.file-icon {
    display: flex;
    align-items: center;
    justify-content: center;
}

.file-preview {
    width: 40px;
    height: 40px;
    object-fit: cover;
    border-radius: 4px;
    border: 1px solid #dee2e6;
}

.file-info {
    flex-grow: 1;
    min-width: 0;
}

.file-info p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.font-12 {
    font-size: 12px;
}

.font-14 {
    font-size: 14px;
}

.h-240px {
    min-height: 240px;
}

.h-auto {
    min-height: auto;
}

.field-error {
    color: #dc3545;
    font-size: 12px;
    margin-top: 5px;
}

.manifest-file-remove {
    position: static !important;
    cursor: pointer;
    transform: none !important;
}

.upload-btn-wrapper .img-2 {
    top: 40% !important;
}
</style>